module.exports = __webpack_public_path__ + "static/media/student-score-matching.4e5b9b08.png";